import React from 'react';
import { useSubmissionsContext } from '../../context/submissions';
import { Cross } from '../icons/icons';
import MaterialLogFilters from './dropdown/MaterialLogFilters';
import { staticBooleanFiltersMapping } from 'utils/submissions';
import { COLORS } from 'colors';
import returnTextDots from 'utils/returnTextDots';

const RenderFilters = () => {
  const { filters, setFilters } = useSubmissionsContext();

  const removeFilter = (type) => {
    setFilters((prevFilters) => {
      const updated = { ...prevFilters };
      delete updated[type];
      return updated;
    });
  };

  const returnFilterValue = (type, values) => {
    const valuesCount = values?.length;
    if (valuesCount > 1) {
      return valuesCount + ' ' + type?.toLowerCase() + 's';
    } else {
      return (
        staticBooleanFiltersMapping?.[type]?.[values] ?? (Array.isArray(values) && values?.at(0))
      );
    }
  };
  const renderOperator = (value) => {
    const valuesCount = value?.length;
    if (valuesCount > 1) {
      return 'is any of';
    } else {
      return 'is';
    }
  };
  const renderFilters = () =>
    Object.entries(filters || {}).map(([type, filter]) => {
      if (type !== 'isArchived' && filter) {
        const typeLabel = type?.replace('_', ' ');
        return (
          <div
            key={type}
            className={`flex items-center gap-1.5 px-3 py-2 border border-[${COLORS.BORDER}] rounded-md whitespace-nowrap`}>
            <div className="flex capitalize">{typeLabel}</div>
            {renderOperator(filter)}
            <div className="font-medium">{returnTextDots(10, returnFilterValue(type, filter))}</div>
            <button type="button" onClick={() => removeFilter(type)}>
              <Cross className="group-hover:text-primary transition-all duration-300" />
            </button>
          </div>
        );
      }
    });

  return (
    <div className="flex items-center gap-2 text-xs font-inter">
      <MaterialLogFilters />
      {renderFilters()}
    </div>
  );
};

export default RenderFilters;
